import { Placement } from 'react-joyride';
import { BaseTour } from '../types';

export class SideBarNavTour extends BaseTour {
  id = 'sidebar';
  content = 'Sidebar Navigation Tour';
  placement: Placement = 'right';
  steps = {
    menuHeader: () => ({
      content: 'Welcome! This is your main navigation menu. You can access all key features from here.',
    }),
    audit: () => ({
      content: 'Review and manage audit exceptions to ensure financial accuracy.',
    }),
    performance: () => ({
      content: 'Track and evaluate service provider performance metrics.',
    }),
    analytic: () => ({
      content: 'Access detailed reports and analytics to gain insights into your logistics operations.',
    }),
    rateCard: () => ({
      content: 'Manage and update rate cards for different service providers and modalities.',
    }),
    askFreya: () => ({
      content: 'Get assistance and answers to your questions using our AI-powered assistant, Freya.',
    }),
    internalDashboard: () => ({
      content: 'Monitor system health, track file ingestion, and manage operational issues across the platform.',
    }),
    settings: () => ({
      content: 'Manage user permissions, legal entities, service providers, and platform-wide configurations.',
      placement: 'top' as Placement,
    }),
    helpCenter: () => ({
      content: 'Access the Help Center for guides, tutorials, and support.',
    }),
    sidebarToggle: (isCollapsed: boolean) => ({
      content: isCollapsed
        ? 'You can expand the sidebar to access the main navigation menu.'
        : 'You can collapse the sidebar to get more screen space for your data.',
    }),
  } as const;
}
